import {
  Edit,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  useNotify,
  useRedirect,
} from "react-admin";
import Grid from "@mui/material/Grid";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";
import { GoogleCalendarColorInput } from "@/components/GoogleCalendarColorInput";

export const BookingPurposeEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Edit
      transform={(data: Record<string, unknown>) => {
        const { calendarColorId: rawColor, ...rest } = data;
        const calendarColorId =
          typeof rawColor === "string" && rawColor.trim() !== "" ? rawColor.trim() : null;
        return { ...rest, calendarColorId };
      }}
      mutationOptions={{
        onSuccess: (data) => {
          notify("Booking purpose updated successfully");
          redirect("show", "bookingPurpose", data.id);
        },
      }}
    >
      <SimpleForm>
        <TextInput source="id" label="Purpose ID" disabled fullWidth helperText="Must be unique" />
        <TextInput source="name" label="Name" fullWidth required />
        <GoogleCalendarColorInput
          source="calendarColorId"
          label="Google Calendar color"
          helperText="Used when raza-backed events with this purpose sync to Google Calendar. Ohbat events keep their own color."
        />
        <ArrayInput source="hallCharges" label="Hall Charges">
          <SimpleFormIterator>
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 10,
                }}
              >
                <ReferenceInput source="hallId" reference="halls" label="Hall" required>
                  <SelectInput optionText={(record) => `${record.name} (${record.shortCode})`} />
                </ReferenceInput>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 3,
                }}
              >
                <NoArrowKeyNumberInput source="rent" label="Rent (₹)" defaultValue={0} />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 3,
                }}
              >
                <NoArrowKeyNumberInput source="deposit" label="Deposit (₹)" defaultValue={0} />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 2,
                }}
              >
                <NoArrowKeyNumberInput source="acCharges" label="AC Charges (₹)" defaultValue={0} />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 2,
                }}
              >
                <NoArrowKeyNumberInput
                  source="kitchenCleaning"
                  label="Kitchen Cleaning (₹)"
                  defaultValue={0}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 2,
                }}
              >
                <BooleanInput source="includeThaalCharges" label="Include Thaal Charges" />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};

export default BookingPurposeEdit;
